import {useMutation, gql} from '@apollo/client'
import planQueryResult from '../../../CounselingPlans/Model/queryResults/planQueryResult'

const useUpdateTaskFromPlan = (onSuccess = () => {}, onError = () => {}) => {
    return useMutation(
        gql`
            mutation (
                $taskInput: UserTasksInput!
                $stepId: ID!
                $phase: PhaseEnum!
                $planId: ID!
                $taskId: ID!
                $userMeetingId: ID
                ) {
                updateTaskFromPlan (
                    taskInput: $taskInput
                    stepId: $stepId
                    phase: $phase
                    planId: $planId
                    taskId: $taskId
                    userMeetingId: $userMeetingId
                )  {
                    ${planQueryResult}
                }
            }
        `,
        {
            onCompleted: (result) => {
                onSuccess(result)
            },
            onError
        }
    )
}

export default useUpdateTaskFromPlan